import React from 'react';
import FoilImage from 'assets/images/filters/filterFoil.jpg';
import ProvisionalFilterModal from 'cards/components/CardListing/CardListingRedesign/ProvisionalComponents/ProvisionalFilterModal';

const FilterFoilModal = ({ hideModalFn }) => (
  <ProvisionalFilterModal
    title="What's Foil?"
    hideModalFn={hideModalFn}
    imageSrc={FoilImage}
    imageDesc="foil"
    description="Foil stamping uses a heated dye to transfer metallic or pigmented foil onto paper so it permanently adheres to it, adding a touch of glamour and shine. Choose from tons of beautiful foil designs at Zola. You can also add custom foil in gold, silver, or rose gold to editable text on select cards."
    btnText="Got It"
  />
);

export default FilterFoilModal;
